<div class="w-full py-3 px-4">

  <!-- CUSTOMER TAB MENU (Same as Kalakaar) -->
  <div class="overflow-x-auto overflow-y-hidden whitespace-nowrap scrollbar-hide md:overflow-x-hidden">
    <div class="min-w-max flex justify-start items-center gap-4">

      <!-- <a
        routerLink="/customer-management/home"
        routerLinkActive="bg-c19725 text-white font-medium outline-c19725 hover:bg-c19725 hover:text-white"
        class="flex-1 px-4 py-2 rounded-tl-[5px] rounded-bl-[5px]
               border-[0.50px] border-[#D9D9D9]
               flex justify-center items-center text-[#898989]
               text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
        Dashboard
      </a>

      <a
        routerLink="/customer-management/orders"
        routerLinkActive="bg-c19725 text-white font-medium outline-c19725 hover:bg-c19725 hover:text-white"
        class="flex-1 px-4 py-2
               border-[0.50px] border-[#D9D9D9]
               flex justify-center items-center text-[#898989]
               text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
        My Orders
      </a>

      <a
        routerLink="/customer-management/account"
        routerLinkActive="bg-c19725 text-white font-medium outline-c19725 hover:bg-c19725 hover:text-white"
        class="flex-1 px-4 py-2
               border-[0.50px] border-[#D9D9D9]
               flex justify-center items-center text-[#898989]
               text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
        Account
      </a> -->

    </div>
  </div>

  <!-- PAGE CONTENT -->
  <div class="pt-4">
    <router-outlet></router-outlet>
  </div>

</div>
